import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import logo from "../assests/logo_web.png";
import { useNavigate } from "react-router-dom";

const TopBar = () => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    try {
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("userInfo");
      if (token && user) {
        setUserDetails(JSON.parse(user));
      } else {
        setUserDetails(null);
      }
    } catch (e) {
      console.error("Failed to parse user info:", e);
      setUserDetails(null);
    }
  }, []);

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (confirmLogout) {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      setUserDetails(null);
      navigate("/");
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const isLoggedIn = Boolean(localStorage.getItem("token"));

  const drawerItems = isLoggedIn
    ? [
        {
          label: "Home",
          icon: <HomeOutlinedIcon />,
          onClick: () => navigate("/"),
        },
        {
          label: "Special Packages",
          icon: <CardGiftcardIcon />,
          onClick: () => navigate("/special-packages"),
        },
        {
          label: userDetails?.fullName || "Hello",
          icon: <AccountCircleIcon />,
          onClick: () => navigate("/user"),
        },
        {
          label: "Logout",
          icon: <LogoutIcon />,
          onClick: handleLogout,
        },
      ]
    : [
        {
          label: "Book Appointment As Guest",
          icon: <HomeOutlinedIcon />,
          onClick: () => navigate("/booking-doc-list"),
        },
        {
          label: "Special Packages",
          icon: <CardGiftcardIcon />,
          onClick: () => navigate("/special-packages"),
        },
        {
          label: "Login",
          icon: <AccountCircleIcon />,
          onClick: () => navigate("/login"),
        },
      ];

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ width: 250 }}>
      <Box sx={{ p: 2, display: "flex", alignItems: "center" }}>
        <img
          src={logo}
          alt="Trust Doc Logo"
          style={{ height: "50px", objectFit: "contain", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
      </Box>
      <Divider />
      <List>
        {drawerItems.map((item) => (
          <ListItem button key={item.label} onClick={item.onClick}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "rgb(217, 225, 228)" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* Left: Logo */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              my: 1,
            }}
            onClick={() => navigate("/")}
          >
            <img
              src={logo}
              alt="Trust Doc Logo"
              style={{ height: "70px", objectFit: "contain" }}
            />
            <Typography
              variant="caption"
              sx={{ color: "#0e102d", fontWeight: "bold", fontSize: "12px" }}
            >
              TRUST DOC
            </Typography>
          </Box>

          {/* Desktop buttons */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
            {userDetails ? (
              <>
                <Button
                  startIcon={<HomeOutlinedIcon />}
                  onClick={() => navigate("/")}
                  sx={buttonStyles}
                >
                  Home
                </Button>
                <Button
                  startIcon={<CardGiftcardIcon />}
                  onClick={() => navigate("/special-packages")}
                  sx={{ ...buttonStyles, backgroundColor: "#10b981" }}
                >
                  Special Packages
                </Button>
                <Button
                  startIcon={<AccountCircleIcon />}
                  onClick={() => navigate("/user")}
                  sx={{ ...buttonStyles, backgroundColor: "#0e102d" }}
                >
                  {userDetails.fullName || "Hello"}
                </Button>
                <Button
                  startIcon={<LogoutIcon />}
                  onClick={handleLogout}
                  sx={{ ...buttonStyles, backgroundColor: "#ef4444" }}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button
                  onClick={() => navigate("/booking-doc-list")}
                  sx={buttonStyles}
                >
                  Book Appointment As Guest
                </Button>
                <Button
                  startIcon={<CardGiftcardIcon />}
                  onClick={() => navigate("/special-packages")}
                  sx={{ ...buttonStyles, backgroundColor: "#10b981" }}
                >
                  Special Packages
                </Button>
                <Button
                  onClick={() => navigate("/login")}
                  sx={{ ...buttonStyles, backgroundColor: "#0e102d" }}
                >
                  Login
                </Button>
              </>
            )}
          </Box>

          {/* Mobile: Menu icon on right */}
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{ display: { md: "none" } }} // only show on mobile
          >
            <MenuIcon sx={{ color: "#0e102d" }} />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{ display: { md: "none" } }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

const buttonStyles = {
  backgroundColor: "#0e102d",
  color: "#fff",
  borderRadius: "20px",
  textTransform: "none",
  paddingX: 2,
  fontWeight: 600,
  "&:hover": {
    backgroundColor: "#1c1f4d",
  },
};

export default TopBar;
